<template>
    <TopContainer :showAssignmentScore="false">
        <div class="container">
            <div>
                <div id="passwordforget">
                    <img src="./images/passwordforget_image.png" class="passwordforget-img"/>

                    <form ref="form" method="POST" novalidate data-vv-scope="resetPassword" class="passwordforget-form">
                        <h1>WACHTWOORD VERGETEN?</h1>
                        <div v-if="requestSent">
                            <p>Een e-mail met verdere instructies is verzonden, controleer uw inbox.</p>
                            <br/>
                        </div>
                        <span style="padding-top: 15px;">Wachtwoord vergeten? voer je gebruikersnaam of e-mailadres in.</span>
                        <span style="padding-bottom: 15px;">Je ontvangt een link via e-mail om een nieuw wachtwoord in te stellen.</span>

                        <div id="ValidationSummary" style="color: red">
                            <ul>
                                <li v-for="error in errors.all()" :key="error.id">{{ error }}</li>
                            </ul>
                        </div>

                        <label for="LoginTextBox" id="LoginLabel">E-mailadres</label>
                        <input id="LoginTextBox" name="E-mailadres" tabindex="1" type="text" v-validate="'required|email'" v-model="form['resetPassword'].username" />
                    </form>

                    <div class="buttons">
                        <!-- <a href="#" @click.prevent="onCancelClick" id="CancelButton" class="button_small button_login" tabindex="2">Annuleer</a> -->
                        <span style="cursor: pointer;" @click.prevent="onResetPassword(form.resetPassword)" id="ResetButton" class="button_small button_register" tabindex="3">Wachtwoord opnieuw instellen ></span>
                    </div>
                    <div class="bottom"></div>
                </div>
            </div>
        </div>
    </TopContainer>
</template>

<script>

    import Backend from '../services/Backend';
    import Auth from '../services/Auth';

    //components
    import TopContainer from './TopContainer.vue';

    export default {
        components: {
            TopContainer
        },
        props: { },
        data()
        {
            return {
                'requestSent': false,
                'error': null, 
                'message': null,
                'form': {
                    'resetPassword': {
                        username: ''
                    }
                }
            }
        },
        methods: {
            onCancelClick() {
                this.$router.push({ name: 'login'});
            },
            onResetPassword(form) {
                this.error = null;
                this.$validator.validateAll('resetPassword')
                    .then((r) => {
                        if (!r) return;

                        Backend.passwordResetRequest(form.username)
                            .done(() =>
                            {
                                this.requestSent = true;
                            })
                            .catch(() =>
                            {
                                this.errors.remove('email');
                                this.errors.add({
                                    field: 'email',
                                    msg: 'Ingevoerde email adres is niet correct.'
                                });
                            });
                    });
            }
        }
    }
    
</script>
